import { Dayjs } from 'dayjs';
export interface Carrier {
  id: string;
  name: string;
  image?: string;
  code: string;
  status: 'ready' | 'pending' | 'partial';
  totalShipments: number;
  totalInvoiceAmount: number;
  currency: string;
}

export interface AWB {
  id: string;
  number: string;
  carrierWeight: number;
  systemWeight: number;
  carrierCharges: number;
  systemCharges: number;
  date: string;
  origin: string;
  destination: string;
  currency: string;
  selected: boolean;
  status?: 'pending' | 'completed' | 'error';
}

export interface InvoiceData {
  invoiceDate: string;
  dueDate: string;
  selectedAWBs: AWB[];
  totalAmount: number;
}

export interface Shipment {
  shipmentNumber: string;
  createdAt: string;
  weight: number;
  currency: string;
  systemId: string;
  origin: string;
  destination: string;
  carrierId: string;
  serviceProviderId: string;
  code: string;
  amount: number;
  shipmentRouteType: string;
  purchaseInvoiceNumber?: string;
}

export interface ServiceProviderStatsMap {
  [serviceProviderId: string]: Shipment[];
}

export interface CarrierStats {
  _id: string;
  currency: string;
  code: string;
  amount: number;
  shipmentNumbers: string[];
  shipments: number;
}

export interface CarrierStatsMap {
  [carrierId: string]: CarrierStats;
}

export interface UnbilledShipmentsResponse {
  msg: string;
  data: Record<string, CarrierData>;
}

// Filters
export interface UnbilledShipmentsFilters {
  fromDate?: string | Date;
  toDate?: string | Date;
  systems?: string[];
  carriers?: string[];
}

export interface Shipment {
  shipmentNumber: string;
  createdAt: string;
  weight: number;
  currency: string;
  systemId: string;
  origin: string;
  destination: string;
  carrierId: string;
  serviceProviderId: string;
  code: string;
  amount: number;
  status: string;
  shipmentRouteType: string;
}

export interface CarrierData {
  carrierId: string;
  currency: string;
  code: string;
  amount: number;
  shipments: Shipment[];
  shipmentCount: number;
}

export interface FinalSubmissionPayload {
  carrier: Carrier;
  invoiceDate: Dayjs | string;
  dueDate: Dayjs | string;
  carrierReferenceNumber: string;
  invoiceLocation?: string;
  vendorLocation?: string;
  d365AccountDisplayValue?: string;
  awbs: AWB[];
}

export const formatShipmentNumber = (value: any): string => {
  if (value === null || value === undefined) return '';

  // If number (scientific case)
  if (typeof value === 'number') {
    return value.toLocaleString('fullwide', { useGrouping: false });
  }

  return value.toString().trim();
};
